import {SupportInfo} from 'app_api/billing/types';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class SupportInfoClient extends BaseClient<SupportInfo> {
  buildEndpoint() {
    return appApiUrl(`billing/user_support_info`);
  }

  processResponse(response) {
    return response.results;
  }
}

export const supportInfoClient = new SupportInfoClient();
